import React from 'react';
import { XCircle, ArrowLeft, ArrowRight } from 'lucide-react';
import Button from '../components/ui/Button';
import Card from '../components/ui/Card';

const SubscriptionCancelPage: React.FC = () => {
  const handleBackToPricing = () => {
    window.location.href = '/pricing';
  };

  const handleContinueToApp = () => {
    window.location.href = '/app';
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50">
      <Card className="max-w-md mx-auto text-center p-8">
        <div className="text-slate-400 mb-4">
          <XCircle className="w-16 h-16 mx-auto" />
        </div>
        
        <h1 className="text-2xl font-bold text-slate-900 mb-4">Subscription Canceled</h1>
        
        <p className="text-slate-600 mb-6">
          No worries! Your subscription process was canceled and no payment was made. 
          You can still use ThreadIt with our free plan.
        </p>
        
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left">
          <h3 className="font-semibold text-blue-900 mb-2">Free Plan Includes:</h3>
          <ul className="space-y-1 text-sm text-blue-700">
            <li>• 5 Deep Thinking Model messages</li>
            <li>• 20 Conversational Model messages</li>
            <li>• Up to 3 Thought Trees</li>
            <li>• Community Support</li>
          </ul>
        </div>
        
        <div className="space-y-3">
          <Button onClick={handleBackToPricing} variant="primary" className="w-full">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Pricing
          </Button>
          
          <Button onClick={handleContinueToApp} variant="secondary" className="w-full">
            Continue with Free Plan
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
        
        <p className="text-xs text-slate-500 mt-4">
          You can upgrade anytime from within the app or by visiting our pricing page.
        </p>
      </Card>
    </div>
  );
};

export default SubscriptionCancelPage;
